import { Box, Image } from '@wix/design-system';
import { AllPlansIncludedFeatures } from '@wix/premium-purchase-platform/@components';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';

export const BenefitFeatures = () => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();
  const platformContext = PremiumPurchasePlatformModule.internals.useContext();

  return (
    <PremiumPurchasePlatformModule.Provider
      context={{
        ...platformContext,
        purchaseContext: {
          ...platformContext.purchaseContext,
          params: {
            contentType: 'benefits',
          },
        },
      }}
    >
      <AllPlansIncludedFeatures.Root
        titleProps={{
          displayLabel: t('studio_package_picker.header.studio_benefits.title'),
        }}
      >
        {(item) =>
          item.content?.localized?.translationKey && (
            <AllPlansIncludedFeatures.Item
              key={item.content?.localized?.translationKey}
              weight="bold"
              icon={
                <Box
                  width="21px"
                  borderRadius="50rem"
                  height="21px"
                  verticalAlign="middle"
                  align="center"
                >
                  {/* TODO: Remove any */}
                  {(item as any).iconImg ? (
                    <Image
                      src={(item as any).iconImg}
                      width="18px"
                      height="18px"
                      transparent
                    />
                  ) : null}
                </Box>
              }
            >
              {t(item.content?.localized?.translationKey)}
            </AllPlansIncludedFeatures.Item>
          )
        }
      </AllPlansIncludedFeatures.Root>
    </PremiumPurchasePlatformModule.Provider>
  );
};
